import { render, staticRenderFns } from "./ResearcherInlineList.vue?vue&type=template&id=78e092fe&"
import script from "./ResearcherInlineList.vue?vue&type=script&lang=js&"
export * from "./ResearcherInlineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports